const MARKETPLACE_ROOT = "pages.marketplace";

export const sectionPrefixKey = (sectionKey) =>
  `${MARKETPLACE_ROOT}.sections.${sectionKey}`;

export const sectionTitleKey = (sectionKey) =>
  `${sectionPrefixKey(sectionKey)}.title`;

export const sectionDescriptionKey = (sectionKey) =>
  `${sectionPrefixKey(sectionKey)}.desc`;

export const servicePrefixKey = (sectionKey, serviceKey) =>
  `${sectionPrefixKey(sectionKey)}.services.${serviceKey}`;

export const serviceTitleKey = (sectionKey, serviceKey) =>
  `${servicePrefixKey(sectionKey, serviceKey)}.title`;

export const serviceDescriptionKey = (sectionKey, serviceKey) =>
  `${servicePrefixKey(sectionKey, serviceKey)}.desc`;

export const tagLabelKey = (tagKey) => `${MARKETPLACE_ROOT}.tags.${tagKey}`;

export const partnerPrefixKey = (sectionKey, serviceKey, partnerKey) =>
  `${servicePrefixKey(sectionKey, serviceKey)}.partners.${partnerKey}`;

export const partnerNameKey = (sectionKey, serviceKey, partnerKey) =>
  `${partnerPrefixKey(sectionKey, serviceKey, partnerKey)}.name`;

export const partnerDescriptionKey = (sectionKey, serviceKey, partnerKey) =>
  `${partnerPrefixKey(sectionKey, serviceKey, partnerKey)}.desc`;

export const partnerAboutKey = (sectionKey, serviceKey, partnerKey) =>
  `${partnerPrefixKey(sectionKey, serviceKey, partnerKey)}.about`;

export const partnerCardTitleKey = (
  sectionKey,
  serviceKey,
  partnerKey,
  slot,
) => `${partnerPrefixKey(sectionKey, serviceKey, partnerKey)}.card${slot}.title`;

export const partnerCardTextKey = (
  sectionKey,
  serviceKey,
  partnerKey,
  slot,
) => `${partnerPrefixKey(sectionKey, serviceKey, partnerKey)}.card${slot}.text`;

export const partnerInfoValueKey = (
  sectionKey,
  serviceKey,
  partnerKey,
  fieldKey,
) => `${partnerPrefixKey(sectionKey, serviceKey, partnerKey)}.info.${fieldKey}.value`;

export const partnerInfoLabelKey = (
  sectionKey,
  serviceKey,
  partnerKey,
  fieldKey,
) => `${partnerPrefixKey(sectionKey, serviceKey, partnerKey)}.info.${fieldKey}.label`;

export const facetLabelKey = (facetType, facetKey) => {
  if (!facetType || !facetKey) return "";

  const typeSegment =
    facetType === "Category"
      ? "category"
      : facetType === "CompatibleWith"
        ? "compatible_with"
        : null;

  return typeSegment
    ? `${MARKETPLACE_ROOT}.facets.${typeSegment}.${facetKey}`
    : "";
};

export const standardPartnerInfoLabelKey = (kind) => {
  switch (kind) {
    case "Requirement":
      return `${MARKETPLACE_ROOT}.partner.info_labels.requirement`;
    case "DataProtection":
      return `${MARKETPLACE_ROOT}.partner.info_labels.data_protection`;
    case "Setup":
      return `${MARKETPLACE_ROOT}.partner.info_labels.setup`;
    case "Support":
      return `${MARKETPLACE_ROOT}.partner.info_labels.support`;
    case "Category":
      return `${MARKETPLACE_ROOT}.partner.info_labels.category`;
    case "CompatibleWith":
      return `${MARKETPLACE_ROOT}.partner.info_labels.compatible_with`;
    default:
      return "";
  }
};

export const resolveTranslationText = (t, key, fallback = "") => {
  if (!key) return fallback;

  const value = t(key);
  return value === key ? fallback : value;
};
